import { trackLink } from "utils/analyticsFramework";

let clickLocked = false;

export const resetClickLock = () => {
	clickLocked = false;
};

const AnalyticsWrapper = ({
	analyticsLinkId,
	children,
	pageTransitionLink = true,
}) => (
	// eslint-disable-next-line jsx-a11y/anchor-is-valid
	<a
		name={analyticsLinkId ? `&lid=${analyticsLinkId}` : null}
		tabIndex={-1}
		style={{ display: "contents" }}
		onClick={() => {
			if (analyticsLinkId) {
				if (pageTransitionLink) clickLocked = true;
				trackLink({ linkId: `${analyticsLinkId}_CLICK`, pageTransitionLink });
			}
		}}
		onMouseEnter={() => {
			if (analyticsLinkId && !clickLocked) {
				trackLink({ linkId: `${analyticsLinkId}_HOVER`, pageTransitionLink });
			}
		}}
		className="syndicated-analytics-wrapper"
	>
		{children}
	</a>
);

export default AnalyticsWrapper;
